import { View } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import ExemptionViewModel from "viewModels/notice/exemption/exemptionViewModel";
import ExemptionReasonSelect from "./exemptionReasonView";

const ExemptionNotice: FunctionComponent<{
  vm: ExemptionViewModel;
}> = observer(({ vm }) => (
  <div>
    <div className="d-flex flex-row flex-wrap justify-content-between align-items-center">
      <h3>{vm.translateGeneral("title")}</h3>
    </div>
    <View vm={vm.vehicleInfoViewModel} />
    <ExemptionReasonSelect vm={vm} />
  </div>
));

export default ExemptionNotice;
